import { configureStore } from "@reduxjs/toolkit";
import persisteReducer from "./rootReducer";
import { persistStore } from "redux-persist";

export const store = configureStore({
  reducer: persisteReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
